import React, {useEffect, useState} from 'react';
import {selectContact} from '../../Redux/actions/contactAction';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import styled from "styled-components";
import {RiAccountCircleFill} from "react-icons/ri";
import {setAlert} from "../../Redux/actions/alertAction";
import axios from "axios";
import {getFriendRequestsRoute} from "../../utils/apiRoutes";
import PuffLoader from "react-spinners/PuffLoader";
import multiavatar from "@multiavatar/multiavatar/esm";

const FriendRequests = ({selectContact, setAlert}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [accountIndex, setAccountIndex] = useState(null);
    const [friendRequests, setFriendRequests] = useState([]);

    useEffect(() => {
        async function fetchData() {
            await getFriendRequests();
        }

        fetchData();
    }, []);

    const getFriendRequests = async () => {
        try {
            const res = await axios.get(getFriendRequestsRoute);
            setFriendRequests(res.data);
            setIsLoading(false);
        } catch (err) {
            const errors = err.response.data.errors;
            if (errors) {
                errors.forEach((error) => setAlert(error.msg, 'error'));
            }
        }
    }

    const accountsToShow = (contact, index) => {
        return (
            <div key={index} onClick={() => {
                setAccountIndex(index);
                selectContact(contact);
            }}>
                <div
                    className={`account-container ${accountIndex === index ? "account-container-selected" : null}`}>
                    <div>
                        {
                            contact.avatarImage ?
                                <div className='avatar avatar-icon'
                                     dangerouslySetInnerHTML={{__html: multiavatar(contact.avatarImage)}}>
                                </div>
                                :
                                <RiAccountCircleFill className='avatar-icon'/>
                        }
                    </div>
                    <div className="account-detail-container">
                        <h4>{contact.name}</h4>
                        <p>{contact.email}</p>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <Container>
            <div style={{paddingTop: 20}}>
                <div className='header'>
                    <h3>Friend Requests</h3>
                </div>
            </div>

            <div style={{marginTop: 20, overflowY: "auto"}}>
                {
                    isLoading ?
                        <div className='spinner-container' ><PuffLoader color="#7269EF"/></div>
                        :
                        friendRequests.length > 0 ?
                        friendRequests.map((friendRequests, index) =>
                            accountsToShow(friendRequests, index)
                        )
                        :
                        <p>No accounts to show!</p>
                }
            </div>
        </Container>

    );
}

FriendRequests.propTypes = {
    selectContact: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    setAlert: PropTypes.func.isRequired
});

export default connect(mapStateToProps, {selectContact, setAlert})(FriendRequests);

const Container = styled.div`
  background-color: #F5F7FB;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0px 8px;
  border-left: #ECEDF6 solid 2px;
  border-right: #ECEDF6 solid 2px;

  @media screen and (max-width: 1000px) {
    .header {
      margin-top: 59px;
    }
  }
  
  .form-input-container {
    position: relative;
    display: flex;
  }

  .header {
    padding: 12px 16px 24px 16px;
  }

  .search-box-container {
    padding: 0 16px 24px 16px;
  }

  .form-input-icon {
    color: #7a7f9a;
    padding: 0.7rem 1rem;
    font-size: 1.2rem;
    line-height: 1.5;
    white-space: nowrap;
    background-color: #E6EBF5;
    border: 1px solid #e6ebf5;
    border-bottom-left-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
  }

  .form-input {
    width: 100%;
    margin-left: -1px;
    padding: 0.5rem 0;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #7a7f9a;
    background-color: #E6EBF5;
    border: 1px solid #e6ebf5;
    border-bottom-right-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  .contact {
    padding: 20px 0;
    transition: 0.25s;
  }

  .isSelected {
    background-color: red !important;
  }

  .account-container {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: 0.5s;
    margin: 2px auto;
    border-radius: 0.5rem;

    :hover {
      background-color: #E6EBF5;
    }
  }

  .account-detail-container {
    display: flex;
    flex-direction: column;
  }

  .avatar {
    width: 2.3rem;
    padding: 16px !important;
  }

  .avatar-icon {
    font-size: 40px;
    padding: 15px;
  }

  .account-container-selected {
    background-color: #E6EBF5;
  }

  .remove-search-container {
    display: flex;
    justify-content: space-between;

    .close-icon {
      font-size: 25px;
      cursor: pointer;
    }
  }

  .spinner-container{
    display: flex;
    justify-content: center;
    padding-top: 25px;
    overflow: hidden;
    height: 100px;
  }

  .hidden {
    display: none !important;
  }
`;